var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.86426 1C3.64045 1 1.0249 3.09071 1.0249 5.6657C1.0249 8.62858 4.91781 13.3239 6.34723 14.9457C6.40657 15.0141 6.48434 15.0698 6.57419 15.1082C6.66404 15.1466 6.76344 15.1667 6.86426 15.1667C6.96508 15.1667 7.06448 15.1466 7.15433 15.1082C7.24418 15.0698 7.32195 15.0141 7.38129 14.9457C8.81071 13.3246 12.7036 8.63097 12.7036 5.6657C12.7036 3.09071 10.0881 1 6.86426 1Z",
    stroke: "#C4E332",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.86418 7.66732C7.93917 7.66732 8.81063 6.92113 8.81063 6.00065C8.81063 5.08018 7.93917 4.33398 6.86418 4.33398C5.78918 4.33398 4.91772 5.08018 4.91772 6.00065C4.91772 6.92113 5.78918 7.66732 6.86418 7.66732Z",
    stroke: "#C4E332",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.13a91ce38154798d1cc0e950eb6495dc.svg";
export { ForwardRef as ReactComponent };